import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import config from '../configuration/config.json';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Buffer } from 'buffer';
import { Base64 } from 'js-base64';
import './IDProofing.css';
import {
    Row, Col, Button, Alert, Card, Modal
} from 'react-bootstrap';
import nfcscanvisual from "../images/nfcscanvisual.gif";
import nfcabouticon from "../images/Vector.png";
import superappLogo from '../icons/1024x1024ia.png';
import walletLogo from '../icons/1024x1024ia-1.png';
import {UAParser} from 'ua-parser-js';

Base64.extendUint8Array();

function StartIDProofing() {
    const title = 'goID ID Proofing Portal';
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [applink, setApplink] = useState("");
    const [cardType, setCardType] = useState("");
    const [isNFC, setIsNFC] = useState(false);
    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [modalShow, setModalShow] = React.useState(false);
    const [isAppOpened, setisAppOpened] = useState(false);

    let { aid } = useParams();

    const appMode = localStorage.getItem('AppMode');
   
    useEffect(() => {
        let cardType = localStorage.getItem('CardType');
        setCardType(cardType);
        let verifier = config.idproofing.verifiers.openid4vp.find(v => v.cardType == cardType);
        if (verifier) {
            startVerify(verifier);
        }
        else {
            setIsNFC(true);
            getNFCDeeplink();
        }
    }, []);

    async function startVerify(verifier) {

        try {
            let headers = {
                'Authorization': "Bearer " + (verifier.bearerToken || config.idproofing.token),
                "content-type": "application/json",
            };

            //let aditionalinfo = {};
            //let cardType = localStorage.getItem('CardType');
            // aditionalinfo.cardType = cardType;
            // aditionalinfo.verifierId = verifierid;
            // aditionalinfo.transactionId = aid;

            const parser = new UAParser();
            const os = parser.getOS();
            let osTypeName = os.name.toLowerCase() || 'others';


            const response = await axios.request({
                method: 'POST',
                url: config.idproofing.openid4vpapibaseurl + "openid4vp/api/reader/request",
                headers: headers,
                responseType: 'application/json',
                data: {verifierId: verifier.id, transactionId: aid, cardType: cardType, 
                    platform: osTypeName, appname: appMode}
            });

            if (response.status == 200) {
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse);
               // let applinkd = new Buffer(response.data);
               // var qrData = config.idproofing.deeplinkurl + applinkd.toBase64URL();
                setIsNFC(false);
                setApplink(jsonData.deepLink);
                 if (appMode == 'D' || appMode != 'W') {
                    window.location.replace(jsonData.deepLink);
                }
               // setApplink(qrData);
                setIsLoading(false);
            } else {
                setIsLoading(false);
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse);
                setErrorMessage(jsonData.message);
                setShow(true);
            }

        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else {
                setErrorMessage(e.message);
            }
            setShow(true);
            setIsLoading(false);
        }
    }

    async function getNFCDeeplink() {
        try {
            let headers = {
                'Authorization': "Bearer " + config.idproofing.token
            };
            const response = await axios.request({
                method: 'GET',
                url: config.idproofing.apibaseurl + "idproofing/nfc/" + aid,
                headers: headers,
                responseType: 'application/json'
            });

            if (response.status == 200) {
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse);
                let applinkd = jsonData.redirectUrl;
                setApplink(applinkd);

            } else {
                setIsLoading(false);
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse)
                setErrorMessage(jsonData.message);
                setShow(true);
            }
        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else {
                setErrorMessage(e.message);
            }
            setShow(true);
            setIsLoading(false);
        }
    }
    async function openwebShare(text) {
        try {
            let resultURL = config.idproofing.baseurl + "idproofing/result/" + aid;

            const shareData = {
                text: text,
                url: resultURL,
            };

            await navigator.share(shareData);
        } catch (e) {
            setErrorMessage(e.message);
            setShow(true);
        }
    }

    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <p align="center" className="scaninstructiondisplay">
                        <b>For using NFC to read the chip, please ensure NFC is enabled.</b><br /><br />
                        Then, move the passport across the back of the phone until it vibrates or begins reading
                    </p>
                </Modal.Body>
                <Modal.Footer style={{
                    display: "flex",
                    justifyContent: "center",
                }}>
                    <Button pill variant="outline-secondary" onClick={props.onHide}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <main className="mainbg">

                <div class="container-fluid  text-center">
                    <div class="row">
                        <div class="col bannerdisplay">
                            
                            <div className="headerdiv">
                                <h1 className="headerdisplay">{title}</h1>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col contentarea">
                            <div class="container-fluid">

                                <div class="row">
                                    <div class="col">
                                        <div class="mx-auto">
                                            {(isNFC == true) ? (
                                                <div class="container-fluid">
                                                  
                                                    <div class="row">
                                                        <div class="col">
                                                         {!isAppOpened &&
                                                                                    <div>
                                                                            <p style={{ marginBottom: "20px" }}>
                                                                                <div><span>Electronic document: ToppanApp will use NFC to read your document.</span></div>
                                                                                <br />
                                                                                <div><span>Click to open app:</span></div>
                                                                            </p></div>}
                                                        </div></div>
                                                    <div class="row">
                                                        <div class="col">
                                                         
                                                            <div>

                                                                <div class="loader-container">
                                                                    <div class="loading-text">
                                                                        {applink === "" ? <span class="dots">Processing</span>  :
                                                                            <div>
                                                                                {!isAppOpened &&
                                                                                    <div>
                                                                         

                                                                            <div>
                                                                                <button
                                                                                    key={appMode === 'toppansuperapp' ? "Toppan SuperApp" : "Toppan Wallet"}
                                                                                    type="button"
                                                                                    aria-label={appMode === 'toppansuperapp' ? "Toppan SuperApp" : "Toppan Wallet"}
                                                                                    title={appMode === 'toppansuperapp' ? "Toppan SuperApp" : "Toppan Wallet"}
                                                                                    disabled={isLoading}
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        /*if (appMode == 'toppansuperapp') {
                                                                                            window.location.replace(applink);
                                                                                        } else {
                                                                                            openwebShare(applink)
                                                                                        }*/
                                                                                        window.location.replace(applink);
                                                                                        setisAppOpened(true);
                                                                                    }}
                                                                                    style={{
                                                                                        display: "inline-flex",
                                                                                        alignItems: "center",
                                                                                        gap: 8,
                                                                                        padding: "8px 12px",
                                                                                        border: "1px solid #ddd",
                                                                                        borderRadius: 6,
                                                                                        background: "#fff",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                >
                                                                                   
                                                                                    <img
                                                                                        src={appMode === 'toppansuperapp' ? superappLogo : walletLogo}
                                                                                        alt=""                    // empty alt since label is visible
                                                                                        width={60}
                                                                                        height={60}
                                                                                        style={{ display: "block" }}
                                                                                    />

                                                                                </button>


                                                                            </div>
                                                                        </div>
                                                                                }
                                                                            </div>
                                                                        }
                                                                        </div>
                                                                </div>

                                                            </div>

                                                        </div></div>
                                                </div>
                                            ) : (
                                                <div>
                                                        <div>

                                                            <div class="loader-container">
                                                                <div class="loading-text">
                                                                    {applink === "" ? <span class="dots">Processing</span> :
                                                                        <div>
                                                                            <Card>
                                                                                <Card.Body>
                                                                                    Click to open app if not opened:
                                                                                </Card.Body>
                                                                            </Card>
                                                                            {!isAppOpened &&
                                                                                <Button className="btn btn-primary btn-lg px-4 gap-3"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        if (appMode == 'D' || appMode != 'W') {
                                                                                            window.location.replace(applink);
                                                                                        } else {
                                                                                            openwebShare(applink)
                                                                                        }
                                                                                        setisAppOpened(true);
                                                                                    }}
                                                                                >
                                                                                    <span className="px-2">Read Mobile ID</span>
                                                                                </Button>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    </div>
                                                            </div>

                                                        </div>
                                                    <hr />
                                                    <div>
                                                            <Card>
                                                                <Card.Body>
                                                                    During that step, your wallet app will be requested for the relevant mobile ID attributes to confirm your identity.
                                                                </Card.Body>
                                                            </Card>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
                <MyVerticallyCenteredModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                />
            </main>
            <Alert show={show} variant="danger" onClose={() => setShow(false)} dismissible>
                <Alert.Heading>Error!</Alert.Heading>
                <p>
                    {errorMessage}.
                </p>
            </Alert>
        </>
    );
}

export default StartIDProofing;
